<template>
  <OpportunityErrorScreen v-if="hasError" title="Street View is not available" />
  <VMapStreetViewPanorama
    v-else
    :show-zoom-control="true"
    :options="STREET_VIEW_MAP_OPTIONS"
    :place="{ lat, lng: lon }"
    @error="setHasError(true)"
  >
    <template #zoomControls="{ disabled, zoomIn, zoomOut }">
      <PropertyDetailsMediaZoomControls
        :disabled="disabled"
        @zoom-in="zoomIn"
        @zoom-out="zoomOut"
      />
    </template>
  </VMapStreetViewPanorama>
</template>

<script setup lang="ts">
  // Types
  import type { RuntimeConfig } from 'nuxt/schema';
  import type { TMapLibConfig } from '~/misc/v-map/types';

  // Config
  import { STREET_VIEW_MAP_OPTIONS } from '~/misc/opportunity/property-details/media/config';
  import { mapLibConfigInjectionKey } from '~/misc/v-map-street-view-panorama/config';

  // Components
  import VMapStreetViewPanorama from '~/misc/v-map-street-view-panorama';
  import PropertyDetailsMediaZoomControls from '~/misc/opportunity/property-details/media/zoom-controls/PropertyDetailsMediaZoomControls.vue';
  import OpportunityErrorScreen from '~/misc/opportunity/error-screen/OpportunityErrorScreen.vue';

  const props = defineProps<{
    gmapApiKey: string | undefined;
    lat: number;
    lon: number;
  }>();

  const hasError: Ref<boolean> = ref<boolean>(false);

  if (typeof props.gmapApiKey === 'string') {
    const config: RuntimeConfig = useRuntimeConfig();
    const libraries: string | boolean | undefined = config.public.GMAP_API_LIBRARIES;

    provide<TMapLibConfig>(mapLibConfigInjectionKey, {
      apiKey: props.gmapApiKey,
      libraries: typeof libraries === 'string' ? libraries : '',
    });
  }

  const setHasError = (state: boolean) => {
    hasError.value = state;
  };

  watch(
    () => [props.lat, props.lon],
    () => setHasError(false)
  );
</script>
